/**
 * Gets size of a blob image and returns size to callback function 
 * @param image 
 * @param updateFunction 
 */
export const getSize = (image, updateFunction: React.Dispatch<React.SetStateAction<number>>): void => {
    const xhr: XMLHttpRequest = new XMLHttpRequest();
    xhr.responseType = 'blob';

    xhr.onload = async (): Promise<void> => {
        const recoveredBlob: any = xhr.response;

        updateFunction(recoveredBlob.size as number)
    };

    xhr.open('GET', image as any);
    xhr.send();
}

/**
 * Grets a base64 image url and stores it in session storage
 * Creates an image element and sets the src to the base64 image
 * @param imageString 
 * @returns 
 */
export const getImage = (imageString: string): string => {
    sessionStorage.setItem('base64Image', imageString);
    let imgElement = document.createElement('img');
    imgElement.src = imageString;
    return imageString;
};

/**
 * Stores image in session storage and creates an image element of the image
 * @param imageString 
 * @param updateFunction 
 */
export const getDimensions = (imageString: string, updateFunction: React.Dispatch<React.SetStateAction<string>>): void => {
    sessionStorage.setItem('base64Image', imageString);
    let imgElement = document.createElement('img');

    imgElement.onload = () => {
        updateFunction(`${imgElement.width}x${imgElement.height}`);
    };

    imgElement.src = imageString;
};

export const getb64 = (image: string, state, setState): void => {
    const xhr: XMLHttpRequest = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = async (): Promise<void> => {
        const recoveredBlob: any = xhr.response;
        const reader: FileReader = new FileReader();

        reader.onload = (): void => {
            let image: string | ArrayBuffer | null = reader.result;
            setState({ ...state, temp: image as string });
        };

        reader.readAsDataURL(recoveredBlob);
    };

    xhr.open('GET', image as any);
    xhr.send();
};
